import React from 'react';
import PropTypes from 'prop-types';

const PiggyBankAlt = ({ color = '#14AE5C', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.5}
      d="m9.922 1.461.704 2.625m.158-2.035c-.081-.302-.44-.468-.803-.37-.362.096-.59.42-.51.722.081.302.44.468.803.37.363-.096.722.07.803.372.08.302-.147.626-.51.723-.362.097-.722-.07-.803-.371"
    />
    <path stroke={color} strokeLinecap="round" strokeWidth={0.8} d="M8.672 1.172a2.265 2.265 0 1 1-.587 1.016" />
    <path
      fill={color}
      d="M6.735 10.082a.775.775 0 1 1-1.55 0 .775.775 0 0 1 1.55 0Zm1.176-1.545a6.82 6.82 0 0 1 1.887-.263c.688 0 1.346.1 1.956.282a.517.517 0 0 0 .296-.99 7.853 7.853 0 0 0-2.252-.325 7.9 7.9 0 0 0-2.172.301.517.517 0 0 0 .285.995Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M9.908 5.667c-3.275 0-6.13 1.93-6.954 4.675H2.35c-.16 0-.319.036-.464.106-.145.07-.274.172-.377.298a1.145 1.145 0 0 0-.242.924l.28 1.654c.066.395.266.752.564 1.01.297.258.673.4 1.062.4h.29a6.39 6.39 0 0 0 1.26 1.565l-.803 2.808a.583.583 0 0 0 .088.5.554.554 0 0 0 .44.226h2.2a.54.54 0 0 0 .318-.103.566.566 0 0 0 .201-.273l.53-1.531a8.185 8.185 0 0 0 2.213.302c.778 0 1.527-.107 2.232-.308l.597 1.555c.04.106.111.196.202.26a.539.539 0 0 0 .31.098h2.2a.538.538 0 0 0 .442-.23.576.576 0 0 0 .084-.5l-.837-2.841c1.201-1.112 1.96-2.626 1.96-4.315 0-.164-.007-.327-.021-.488a2.79 2.79 0 0 0 .775-.503c.347.347.897.347.897-.473 0 .253-.55.253-.507-.03a1.16 1.16 0 0 0 .099-.288.815.815 0 0 0-.223-.731.623.623 0 0 0-.778-.111.825.825 0 0 0-.28.267.856.856 0 0 0-.132.37c-.026.275.09.544.352.74-.09.066-.186.124-.285.174-.587-3.019-3.613-5.208-7.088-5.208ZM3.914 11.03C4.414 8.689 6.848 6.8 9.908 6.8 13.37 6.8 16 9.196 16 11.947c0 1.422-.686 2.732-1.837 3.682a.583.583 0 0 0-.182.606l.726 2.465h-1.083l-.65-1.685a.56.56 0 0 0-.282-.307.535.535 0 0 0-.41-.02c-.727.26-1.529.407-2.373.407a7.07 7.07 0 0 1-2.373-.407.535.535 0 0 0-.418.024.561.561 0 0 0-.28.32L6.257 18.7H5.181l.697-2.437a.583.583 0 0 0-.187-.605 5.237 5.237 0 0 1-1.413-1.746.56.56 0 0 0-.203-.228c.646-.217-.186-.084-.288-.084h-.616a.54.54 0 0 1-.354-.133.571.571 0 0 1-.187-.336l-.28-1.655h1.027a.54.54 0 0 0 .344-.125.57.57 0 0 0 .193-.32Zm13.886-.972a.688.688 0 0 1-.107.238l-.049-.028c-.16-.102-.172-.198-.167-.253a.276.276 0 0 1 .129-.196c.054-.03.088-.024.124.014a.227.227 0 0 1 .07.225Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      stroke={color}
      d="M5.202 6.949c.079.046.173.124.271.212l-.203.17-.146-.422c.028.013.055.026.078.04Z"
    />
  </svg>
);

PiggyBankAlt.propTypes = {
  color: PropTypes.string
};

export default PiggyBankAlt;
